import LTR from "@brand-icons/global/sound-on/sound-on-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SoundOnIcon = iconFactory("SoundOnIcon", LTR);
